import { useTranslation } from 'react-i18next'

import { Form } from 'app/common/presentation'
import { useUser } from 'app/user/application'

import styles from './Workspace.module.scss'

const WorkspaceSelectSettings = () => {
  const { t } = useTranslation('settings')
  const { workspace } = useUser()

  const name = workspace?.name ?? ''

  return (
    <div className={styles.workspace}>
      <Form.InputFormRow
        description={t('workspace.name.description')}
        title={t('workspace.name.title')}
        value={name}
      />
      <Form.FormRow
        description={t('workspace.delete.description')}
        title={t('workspace.delete.title')}
      />
    </div>
  )
}

export default WorkspaceSelectSettings
